import { render, staticRenderFns } from "./procyon.vue?vue&type=template&id=570353e5&scoped=true&"
import script from "./procyon.vue?vue&type=script&lang=js&"
export * from "./procyon.vue?vue&type=script&lang=js&"
import style0 from "./procyon.vue?vue&type=style&index=0&id=570353e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570353e5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentType1: require('D:/Project/kpwebsite/PC/components/content/content-type-1.vue').default})
